import { getApiEndpointFullyQualifiedDomain } from '../../../util/apiClient/commonApiClient'
import { IAuthRepository } from '../../consumePlayer/repository/AuthRepository'

export class LeaveGameService {
  private _authRepository: IAuthRepository

  constructor(authRepository: IAuthRepository) {
    this._authRepository = authRepository
  }

  registerLeaveGameEvent = () => {
    window.addEventListener('unload', () => {
      const apiURL = `https://${getApiEndpointFullyQualifiedDomain()}/api/common/funkyleavegame`
      const authToken = this._authRepository.getAuth()
      const data = JSON.stringify({ authToken: authToken })
      navigator.sendBeacon(apiURL, data)
    })
  }
}
